import React, { useState, useEffect, Suspense, lazy } from 'react';

// Dynamically import the desktop and mobile versions
const PortfolioDesktop = lazy(() => import('./PortfolioDesktop'));
const PortfolioMobile = lazy(() => import('./PortfolioMobile'));

// A minimal loading fallback to show while the chunk is being downloaded
const LoadingScreen = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    // Simulate progress while the chunk is downloading
    const interval = setInterval(() => {
      setProgress(p => {
        const remaining = 99 - p;
        return p + Math.max(1, remaining * 0.2);
      });
    }, 50);
    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{ 
      height: '100vh', 
      width: '100vw', 
      display: 'flex', 
      flexDirection: 'column',
      alignItems: 'center', 
      justifyContent: 'center', 
      background: '#0a0a0a',
      color: '#00f0ff',
      fontFamily: 'var(--font-mono)'
    }}>
      <div style={{
        width: '250px',
        height: '4px',
        background: 'rgba(255,255,255,0.1)',
        borderRadius: '2px',
        overflow: 'hidden',
        marginBottom: '16px'
      }}>
        <div style={{
          width: `${progress}%`,
          height: '100%',
          background: 'var(--neon, #00f0ff)',
          transition: 'width 0.1s ease-out'
        }} />
      </div>

    </div>
  );
};

const Portfolio = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    // Only detect resize to switch layouts if strictly necessary. 
    // In many adaptive designs, this listener isn't even used to prevent jarring layout swaps.
    // We'll keep it so that resizing the browser on desktop still works for testing.
    let timeoutId = null;
    const handleResize = () => {
      // Debounce the resize event to prevent rapid remounting
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        setIsMobile(window.innerWidth <= 768);
      }, 150);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      clearTimeout(timeoutId);
    };
  }, []);

  return (
    <Suspense fallback={<LoadingScreen />}>
      {isMobile ? <PortfolioMobile /> : <PortfolioDesktop />}
    </Suspense>
  );
};

export default Portfolio;